import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["text-collapsable", { 'text-collapsed': $options.is_collapsed && $data.needs_collapse }])
  }, [
    _createElementVNode("div", {
      ref: "text",
      class: "text-content",
      style: _normalizeStyle({ 'max-height': $options.is_collapsed ? $data.max_height + 'px' : null }),
      innerHTML: $props.content
    }, null, 12 /* STYLE, PROPS */, _hoisted_1),
    ($data.needs_collapse)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass($props.link ? 'text-start pt-0' : 'text-center pt-3')
        }, [
          _createElementVNode("a", {
            class: _normalizeClass($props.link ? 'text-muted small' : 'btn btn-outline-light'),
            href: "#",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => ($data.collapsed = !$data.collapsed), ["prevent","stop"]))
          }, _toDisplayString($data.collapsed
                        ? $options.translations.actions.SHOW_ALL
                        : $options.translations.actions.HIDE) + " → ", 3 /* TEXT, CLASS */)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}